var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex items-center justify-center h-full px-4 focus:outline-none focus:shadow-outline sm:px-5",on:{"click":function($event){return _vm.$emit('action')}}},[_vm._t("default",function(){return [_c('IconCross')]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }